import { render, staticRenderFns } from "./BusinessCustomerDetailsInput.vue?vue&type=template&id=5323c760&scoped=true&"
import script from "./BusinessCustomerDetailsInput.vue?vue&type=script&lang=js&"
export * from "./BusinessCustomerDetailsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5323c760",
  null
  
)

export default component.exports